import { ButtonProps, Search } from '@sparemin/blockhead';
import React from 'react';
import { YoutubeVideoInputValue } from '../types';
import { getYoutubeVideoTitle } from '../utils';
import * as S from './styles';

export type YoutubeVideoNonEmptyInputProps = {
  video: YoutubeVideoInputValue;
  onSearchPress?: ButtonProps['onPress'];
  buttonRef?: React.Ref<HTMLButtonElement>;
};

const YoutubeVideoNonEmptyInput: React.FC<YoutubeVideoNonEmptyInputProps> = ({
  buttonRef,
  video,
  onSearchPress,
}) => (
  <S.Container>
    <S.Player
      key={video.videoId}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
      src={`https://www.youtube.com/embed/${video.videoId}`}
      title={getYoutubeVideoTitle(video)}
    />
    <S.SearchButton onPress={onSearchPress} ref={buttonRef}>
      <Search />
    </S.SearchButton>
  </S.Container>
);

export default YoutubeVideoNonEmptyInput;
